<template>
  <dialogModule
    top="12"
    width="620px"
    :title="$t('deptCollectMoney.ticketGiveTitle')"
    v-if="ticketVisible"
    :dialogVisible="ticketVisible"
    :close-on-press-escape="false"
    @close="close">
    <span slot="close" class="el-icon-close close cursor" @click="close"></span>
    <section slot="content" v-loading="fetchLoading">
      <div class="row align-center space-between scan-goods">
        <div class="scan-input">
          <input
            type="text"
            ref="giftInput"
            v-focusInput="1"
            v-model="giftSku"
            :placeholder="$t('deptCollectMoney.ticketGivePlaceholder')"
            @blur="queryGift"
            @keyup.enter="$event.target.blur()" />
          <i class="iconfont icon-saoma"></i>
        </div>
        <div class="choose-gift">
          {{ $t('deptCollectMoney.ticketGiveGiftLimit', {
            giftNumLimit: currentTicket.giftNumLimit,
            giftNum: currentTicket.giftNum || '0'
          }) }}
        </div>
      </div>
      <div class="give-box">
        <el-empty 
          v-if="!currentTicket || !currentTicket.giftGoodInfos.length" 
          :description="$t('deptCollectMoney.ticketGiveEmptyTip')"></el-empty>
        <div v-else class="goods row align-center space-between" v-for="(item, i) in currentTicket.giftGoodInfos" :key="i">
          <div class="left row align-center">
            <div class="goods-img">
              <el-image v-if="item.imageList && item.imageList.length" class="img" :src="item.imageList[0]" :preview-src-list="item.imageList"></el-image>
              <div v-else class="row align-center space-center">{{ $t('deptCollectMoney.ticketGiveNoImage') }}</div>
            </div>
            <div class="goods-attr">
              <div class="title">{{item.goodsName}}</div>
              <div class="spu">{{item.goodsNo}}</div>
              <div class="attr" v-if="item.attr">
                <span v-for="(val, v) in item.attr.slice(0, 2)" :key="v">{{val.value}}</span>
              </div>
            </div>
          </div>
          <div class="center">
            <div class="tag-price row space-end">{{ $t('deptCollectMoney.ticketGiveTagPrice') }}<span>{{item.tagPrice}}</span></div>
            <div class="sell-price row space-end">{{ $t('deptCollectMoney.ticketGiveRetailPrice') }}<span>{{item.retailPrice}}</span></div>
          </div>
          <div class="right">
            <div class="tag-price">{{ $t('deptCollectMoney.ticketGiveAvailableStock') }}<span>{{item.stock}}</span></div>
            <div class="row align-center space-between num">
              <div class="minus row align-center space-center" @click="minusNum(item, i)"><i class="el-icon-minus"></i></div>
              <div class="input">{{item.number}}</div>
              <div class="plus row align-center space-center" @click="addNum(item, i)"><i class="el-icon-plus"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-center space-end sure">
        <el-button class="btn1" @click="close">{{ $t('deptCollectMoney.ticketGiveClose') }}</el-button>
        <el-button class="btn2" @click="sureGift">{{ $t('deptCollectMoney.ticketGiveConfirm') }}</el-button>
      </div>
    </section>
  </dialogModule>
</template>

<script>
import dialogModule from "@/components/dialogModule.vue"
import {operateGoodsNo} from "@/libs/http/modules/posOrder"
export default {
  components: {
    dialogModule
  },
  props: {
    couponInfo: {
      type: Object,
      default: () => null
    },
    couponInfoList: {
      type: Array,
      default: () => []
    },
    type: {//区分组件入口和券类型
      //1 吊牌价抵扣/固定搭配选品弹窗点击选赠品   2 实卖价抵扣券收银台首页打开
      type: String,
      default: () => ''
    }
  },
  data() {
    return{
      ticketVisible: true,
      infoVisible: true,
      fetchLoading: false,
      giftSku: '',
      addGiftList: [],
      ticketList: [],
      currentTicket: null,
      isDataChange: false
    }
  },
  created() {
    this.ticketList = []
    this.currentTicket = this.couponInfo
    if(this.couponInfoList.length){
      let index = this.couponInfoList.findIndex(item=>{
        return item.certificateId === this.currentTicket.certificateId
      })
      if(index === -1){
        this.ticketList = [...this.couponInfoList, ...[this.currentTicket]]
      }else{
        this.ticketList = this.couponInfoList
      }
    }else{
      this.ticketList = [this.currentTicket]
    }
    this.$nextTick(() => {
      this.$refs.giftInput.focus()
    })
  },
  methods: {
    close(){
      this.ticketVisible = false
      this.$emit('close')
    },
    unifyAction(barCode, type, index){
      if(this.currentTicket.giftNum === this.currentTicket.giftNumLimit && type !== '2'){
        this.giftSku = ''
        this.$message({
          showClose: true, 
          message: this.$t('deptCollectMoney.ticketGiveMaxGiftError'), 
          type: "error", 
          duration: 2000
        })
        return
      }
      this.fetchLoading = true
      let params = {
        type: '6',
        couponInfoList: this.ticketList,
        operateCouponsGoodInfo: {
          barCode: barCode,
          alterGoodsWay: type,
          operationCouponType: '1',
          certificateId: this.currentTicket.certificateId
        }
      }
      if(index){
        params['operateCouponsGoodInfo']['index'] = index
      }
      operateGoodsNo(params).then(res=>{
        this.giftSku = ''
        this.$nextTick(() => {
          this.$refs.giftInput.focus()
        })
        this.ticketList = res.couponGoodInfos
        this.currentTicket = res.couponGoodInfos.find(item=>{
          return item.certificateId === this.currentTicket.certificateId
        })
        this.isDataChange = true
        this.fetchLoading = false
      }).catch(error=>{
        this.giftSku = ''
        this.fetchLoading = false
        this.$nextTick(() => {
          this.$refs.giftInput.focus()
        })
        this.$message({showClose: true, message: error, type: "error", duration: 2000})
      })
    },
    queryGift(){
      if(!this.giftSku) return
      this.unifyAction(this.giftSku, '1')
    },
    minusNum(item, i){
      this.unifyAction(item.barCode, '2', i + '')
    },
    addNum(item, i){
      this.unifyAction(item.barCode, '1', i + '')
    },
    sureGift(){
      this.close()
      if(this.isDataChange){
        if(this.type === '1'){
          this.$emit('gift', this.currentTicket, this.ticketList)
        }else{
          this.$emit('operate', this.currentTicket)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scan-goods{
  margin: 20px;
  .scan-input{
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    border: 1px solid orange;
    input {
      width: 260px;
      line-height: 36px;
      height: 36px;
      outline: none;
      margin-left: 10px;
      font-size: 14px;
      float: left;
      border: none;
      margin-top: 2px;
      background: none;
      color: orange;
      padding-right: 10px;
    }
    i{
      color: orange;
      font-size: 20px;
      font-weight: bold;
      margin-right: 10px;
    }
    input::-webkit-input-placeholder {
      color: #666;
    }
    input:focus {
      color: #c56209;
    }
    input:focus::-webkit-input-placeholder {
      color: #c56209;
    }
  }
  .choose-gift{
    color: #000;
    font-size: 16px;
  }
}
.give-box{
  height: 54vh;
  margin: 20px;
  .goods{
    overflow: hidden;
    margin-bottom: 20px;
    .left{
      .goods-img{
        margin-right: 10px;
        .img{
          width: 80px;
          height: 80px;
          float: left;
          border-radius: 4px;
        }
        div{
          width: 80px;
          height: 80px;
          background: #eee;
          border-radius: 4px;
        }
      }
      .goods-attr{
        .title{
          color: #000;
          font-size: 16px;
          margin-top: -4px;
          font-weight: bold;
        }
        .spu{
          color: #000;
          margin: 8px 0;
          font-size: 16px;
        }
        .attr{
          span{
            padding: 0 4px;
            border-radius: 4px;
            margin-right: 10px;
            border: 1px solid #aaa;
          }
        }
      }
    }
    .center{
      width: 150px;
      height: 80px;
      .tag-price{
        margin-top: 30px;
      }
      span{
        width: 60px;
        font-size: 16px;
      }
      .sell-price{
        margin-top: 8px;
        span{
          color: #000;
        }
      }
    }
    .right{
      width: 130px;
      text-align: right;
      .num{
        height: 50px;
        margin-top: 5px;
        border: 1px solid #eee;
        .input{
          font-size: 20px;
        }
        .minus{
          width: 40px;
          color: #000;
          height: 50px;
          cursor: pointer;
          background: #eee;
          line-height: 50px;
          text-align: center;
        }
        .plus{
          width: 40px;
          color: #fff;
          height: 50px;
          cursor: pointer;
          line-height: 50px;
          text-align: center;
          background: #067CF2;
        }
        i{
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }
  }
}
.sure{
  padding: 10px 0;
  .btn1{
    color: #000;
    width: 120px;
    font-size: 16px;
  }
  .btn2{
    color: #fff;
    width: 120px;
    font-size: 16px;
    margin-right: 20px;
    background: #067CF2;
  }
}
</style>